import { Text, View } from "@react-pdf/renderer";

function ListItem({ item, value, whiteBg, unlimited, last }) {
  return (
    <View
      style={{
        width: "100%",
        backgroundColor: whiteBg ? "#fff" : "#f1f1f1",
        borderTop: last ? "1px solid black" : "none",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <View
        style={{
          width: unlimited ? "100%" : "auto",
          justifyContent: "center",
          alignItems: "flex-start",
          margin: 10,
        }}
      >
        <Text
          style={{
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {item}
        </Text>
      </View>
      <View
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "flex-end",
          margin: 10,
        }}
      >
        <Text
          style={{
            fontWeight: last ? 600 : "normal",
            display: "block",
            fontSize: 11,
          }}
        >
          {value}
        </Text>
      </View>
    </View>
  );
}

export default ListItem;
